// extracted by mini-css-extract-plugin
export var image = "Social-module--image--a15f3";
export var list = "Social-module--list--95a8e";
export var rightForArabicLang = "Social-module--rightForArabicLang--caa31";